module.exports = __webpack_public_path__ + "static/3w_code-aa03cf3f5d5150a8248f3d664aa92307.png";